import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function WordlistStudyButton({ wordlistId }: { wordlistId: string }) {
    const navigate = useNavigate()

    return <Button variant="contained" onClick={() => navigate("/study/" + wordlistId)}>Study this list</Button>
}
